// extracted by mini-css-extract-plugin
export default {"filter":"productFilter_filter__yH+rm","category":"productFilter_category__Aqgj6","brand":"productFilter_brand__Iuwhj","active":"productFilter_active__yAdkf"};